import { createFocusTrap } from './focus-trap.js';

// Navigation scripts
const navmanager = {
    stickyNavScroll: function () {
        const body = document.body;

        var scrollUp = 'scrollup';
        var scrollDown = 'scrolldown';
        var lastScrollTop = 0;

        document.addEventListener('scroll', function () {
            window.requestAnimationFrame(checkScrollDirection);
        });

        function isSafariBrowser() {
            var userAgent = navigator.userAgent;
            return userAgent.indexOf("Safari") !== -1 && userAgent.indexOf("Chrome") === -1 && userAgent.indexOf("Firefox") === -1;
          }
          
          // if (isSafariBrowser()) {
          //   console.log("Current browser is Safari");
          // } else {
          //   console.log("Current browser is not Safari");
          // }

        function checkScrollDirection(event){
            if (checkScrollDirectionIsUp(event)) {
                if (body.classList.contains('safari')) {
                    // Remove the "safari" class
                    body.classList.remove(scrollUp);
                  } else if (checkScrollDirectionIsUp(event)) {
                    body.classList.add(scrollUp);
                    body.classList.remove(scrollDown);
                } else {
                    body.classList.remove(scrollUp);
                    body.classList.add(scrollDown);
                    // Check if body has the "scroll-down" class
                }
            }    
        }
    

        function checkScrollDirectionIsUp(event)
        {
            var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (currentScrollTop > lastScrollTop) {
                lastScrollTop = currentScrollTop;
                return false;
            }

            lastScrollTop = currentScrollTop;

            return true;
        }

        //Knowledge Base Anchors
        const kbanchors = document.querySelectorAll('.kb-article__anchor-link');
        kbanchors.forEach(el => el.addEventListener('click', event => {
            body.classList.add(scrollDown);
            body.classList.remove(scrollUp);
        }));

        //Scroll up
        const scrollups = document.querySelectorAll('.scrollup');
        scrollups.forEach(el => el.addEventListener('click', event => {
            body.classList.remove(scrollDown);
            body.classList.add(scrollUp);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            document.querySelector('.switch-hp-logo').style.display = 'none;'
            //console.log('up');
        }));


    }, observers: function () {
        const headerEl = document.querySelector('.desktop-nav')
        const headermobEL = document.querySelector('.mobile-header')

        if (!headerEl && !headermobEL) return;

        // Previously toggled via IntersectionObserver on a zero-height
        // `.sentinal` div, which unreliably re-fired when scrolling back to
        // scrollY=0 on the home page (target rect collapses to 0 area at the
        // viewport edge), leaving `.scrolled` stuck on and the home header
        // solid blue instead of transparent.
        let timer;
        const apply = () => {
            const scrolled = window.scrollY > 0;
            if (headerEl) headerEl.classList.toggle('scrolled', scrolled);
            if (headermobEL) headermobEL.classList.toggle('scrolled', scrolled);
        };
        const schedule = () => {
            clearTimeout(timer);
            timer = setTimeout(apply, 150);
        };

        window.addEventListener('scroll', schedule, { passive: true });
        apply();
    }, searchtoggle: function () {
        var searchform = document.getElementById('search-modal');
        var searchinput = document.getElementById('s');
        var openBtns = document.querySelectorAll('.open-search');
        var closeBtns = document.querySelectorAll('.close-search');
        var lastTrigger = null;

        var trap = createFocusTrap(searchform, {
            onClose: closeSearch,
            escapeCloses: true
        });

        function openSearch(trigger) {
            lastTrigger = trigger;
            trigger.classList.add('open');
            trigger.setAttribute('aria-expanded', 'true');
            searchform.classList.add('open');
            searchform.setAttribute('aria-hidden', 'false');
            searchform.removeAttribute('inert');
            trap.activate(trigger);
            searchinput.focus();
        }

        function closeSearch() {
            searchform.classList.remove('open');
            searchform.setAttribute('aria-hidden', 'true');
            searchform.setAttribute('inert', '');
            if (lastTrigger) {
                lastTrigger.classList.remove('open');
                lastTrigger.setAttribute('aria-expanded', 'false');
                lastTrigger = null;
            }
            trap.deactivate();
        }

        openBtns.forEach(function (el) {
            el.addEventListener('click', function (event) {
                event.preventDefault();
                if (searchform.classList.contains('open')) {
                    closeSearch();
                } else {
                    openSearch(el);
                }
            });
        });

        closeBtns.forEach(function (el) {
            el.addEventListener('click', function (event) {
                event.preventDefault();
                closeSearch();
            });
        });
    }, megaMenuAccessibility: function () {
        var menuItems = document.querySelectorAll('.desktop-nav .has-megamenu');

        menuItems.forEach(function (item) {
            var trigger = item.querySelector(':scope > button[aria-haspopup]');
            if (!trigger) return;

            var panel = item.querySelector('.mega-nav');
            var focusoutTimer;

            // Set initial inert state on the panel
            if (panel) {
                panel.inert = true;
            }

            function openMenu() {
                item.classList.add('is-open');
                trigger.setAttribute('aria-expanded', 'true');
                if (panel) panel.inert = false;
            }

            function closeMenu() {
                item.classList.remove('is-open');
                trigger.setAttribute('aria-expanded', 'false');
                if (panel) panel.inert = true;
            }

            // Toggle on mouse hover
            item.addEventListener('mouseenter', function () {
                openMenu();
            });

            item.addEventListener('mouseleave', function () {
                // Don't close if keyboard focus is still inside the menu
                if (!item.contains(document.activeElement) || document.activeElement === trigger) {
                    closeMenu();
                }
            });

            // Keyboard and Escape handling
            item.addEventListener('keydown', function (e) {
                if ((e.key === 'Enter' || e.key === ' ') && e.target === trigger) {
                    e.preventDefault();
                    var isOpen = item.classList.contains('is-open');

                    if (isOpen) {
                        closeMenu();
                        return;
                    }

                    openMenu();

                    var firstLink = item.querySelector('.mega-nav__item a');
                    if (firstLink) {
                        firstLink.focus();
                    }
                } else if (e.key === 'Escape' && item.classList.contains('is-open')) {
                    closeMenu();
                    trigger.focus();
                }
            });

            // Close when focus leaves the mega menu entirely
            item.addEventListener('focusout', function () {
                clearTimeout(focusoutTimer);
                focusoutTimer = setTimeout(function () {
                    if (!item.contains(document.activeElement)) {
                        closeMenu();
                    }
                }, 0);
            });

            item.addEventListener('focusin', function () {
                clearTimeout(focusoutTimer);
            });
        });
    }, subMenuAccessibility: function () {
        var menuItems = document.querySelectorAll('.desktop-nav .menu-item-has-children');

        menuItems.forEach(function (item) {
            // Skip mega menu items — handled by megaMenuAccessibility
            if (item.classList.contains('has-megamenu')) return;

            var trigger = item.querySelector(':scope > button[aria-haspopup]');
            if (!trigger) return;

            var panel = item.querySelector(':scope > .sub-menu');
            if (!panel) return;

            var focusoutTimer;

            function openMenu() {
                panel.classList.add('is-open');
                trigger.setAttribute('aria-expanded', 'true');
                trigger.classList.add('open');
            }

            function closeMenu() {
                panel.classList.remove('is-open');
                trigger.setAttribute('aria-expanded', 'false');
                trigger.classList.remove('open');
            }

            trigger.addEventListener('click', function (e) {
                e.preventDefault();
                if (panel.classList.contains('is-open')) {
                    closeMenu();
                } else {
                    openMenu();
                }
            });

            item.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' && panel.classList.contains('is-open')) {
                    closeMenu();
                    trigger.focus();
                }
            });

            item.addEventListener('focusout', function () {
                clearTimeout(focusoutTimer);
                focusoutTimer = setTimeout(function () {
                    if (!item.contains(document.activeElement)) {
                        closeMenu();
                    }
                }, 0);
            });

            item.addEventListener('focusin', function () {
                clearTimeout(focusoutTimer);
            });
        });
    }
}

export default navmanager;